export default "__VITE_ASSET__B$0i7a9R__"